import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { AtSign, CheckCircle2, AlertTriangle, Trash2, Pencil, Zap, Unlink } from "lucide-react";

export const AccountCard = ({ account: a, onToggle, onEdit, onTest, onDisconnect, onDelete }) => (
  <div data-testid={`account-card-${a.id}`} className="border border-[#E5E4E0] bg-white p-5 flex items-center gap-4 flex-wrap">
    <div className="border border-[#E5E4E0] p-2">
      <AtSign size={18} className="text-[#2C4C3B]" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <h4 className="font-display text-xl">{a.label}</h4>
        <span className="text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-0.5 bg-[#F0EFEA] text-[#5C5B5A]">
          {a.provider === "microsoft_oauth" ? "Microsoft OAuth2" : a.provider}
        </span>
        {a.provider === "microsoft_oauth" && a.oauth_connected && (
          <span className="text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-0.5 bg-[#E7F1FC] text-[#0078D4] flex items-center gap-1">
            <Zap size={10} /> Connesso
          </span>
        )}
        {a.provider === "microsoft_oauth" && !a.oauth_connected && (
          <span className="text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-0.5 bg-[#FDF1EB] text-[#C85A32]">
            Token mancante
          </span>
        )}
      </div>
      <div className="text-xs text-[#5C5B5A] font-mono mt-1">{a.email_address}</div>
      {a.last_error ? (
        <div className="text-xs text-[#991B1B] mt-1 flex items-center gap-1">
          <AlertTriangle size={12} /> {a.last_error}
        </div>
      ) : a.last_polled_at ? (
        <div className="text-xs text-[#2C4C3B] mt-1 flex items-center gap-1">
          <CheckCircle2 size={12} /> Ultimo accesso: {new Date(a.last_polled_at).toLocaleString("it-IT")}
        </div>
      ) : null}
    </div>
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <span className="label-mono text-[10px]">Attivo</span>
        <Switch
          data-testid={`account-toggle-${a.id}`}
          checked={a.enabled}
          onCheckedChange={(v) => onToggle(a.id, v)}
          className="data-[state=checked]:bg-[#2C4C3B]"
        />
      </div>
      {a.provider !== "microsoft_oauth" && (
        <Button
          data-testid={`account-edit-${a.id}`}
          onClick={() => onEdit(a)}
          variant="outline"
          className="border-[#2C4C3B] text-[#2C4C3B] hover:bg-[#F0EFEA] font-mono uppercase text-xs tracking-[0.2em]"
        >
          <Pencil size={14} className="mr-1" /> Modifica
        </Button>
      )}
      <Button
        data-testid={`account-test-${a.id}`}
        onClick={() => onTest(a.id)}
        variant="outline"
        className="border-[#2C4C3B] text-[#2C4C3B] hover:bg-[#F0EFEA] font-mono uppercase text-xs tracking-[0.2em]"
      >
        Test
      </Button>
      {a.provider === "microsoft_oauth" && a.oauth_connected && (
        <Button
          data-testid={`account-oauth-disconnect-${a.id}`}
          onClick={() => onDisconnect(a.id)}
          variant="outline"
          className="border-[#8C8B8A] text-[#5C5B5A] hover:bg-[#F0EFEA] font-mono uppercase text-xs tracking-[0.2em]"
        >
          <Unlink size={14} className="mr-1" /> Scollega
        </Button>
      )}
      <Button
        data-testid={`account-delete-${a.id}`}
        onClick={() => onDelete(a.id)}
        variant="outline"
        className="border-[#C85A32] text-[#C85A32] hover:bg-[#FDF1EB] font-mono uppercase text-xs tracking-[0.2em]"
      >
        <Trash2 size={14} />
      </Button>
    </div>
  </div>
);
